import React from "react";
import { MaterialDesignIcons } from "../styled";

/** Значок ♪. Нажатие ловит кнопка вокруг него (AudioManage), не сам значок (проба P50m20d, E6). */
export const MusicNoteMIcon: React.FC<{ fontSize?: string; onClick?: () => void }> = ({
  fontSize,
  onClick,
}) => {
  return (
    <MaterialDesignIcons fontSize={fontSize} onClick={onClick} aria-hidden>
      music_note
    </MaterialDesignIcons>
  );
};
